import './CodeItem.scss';

import classNames from 'classnames';
import { isArray } from 'lodash';
import React from 'react';
import { SanitizedHtml } from './SanitizedHtml';

import { OpenPeriscopeOptions, usePeriscopeActions } from '@hooks';

export interface CodeItemProps {
	className?: string;
	code?: string;
	sections: Array<{
		end: number;
		periscopeOptions?: OpenPeriscopeOptions;
		start: number
	}> | {
		periscopeOptions?: OpenPeriscopeOptions;
	}
}

const GetOnClick = (
	periscopeOptions?: OpenPeriscopeOptions
) => {
	const { openPeriscope } = usePeriscopeActions();

	if (!periscopeOptions) {
		return undefined;
	}

	return (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
		event.stopPropagation();

		openPeriscope(periscopeOptions);
	};
};

export const CodeItem: React.FC<CodeItemProps> = ({ className, code, sections }) => {
	if (!code) {
		return null;
	}

	if (isArray(sections)) {
		let i = 0;

		return (
			<code>
				<div>
					{ sections.map((section) => {
						const { end, start, periscopeOptions } = section;
						const iMoreThanStartChar = i > start;

						if (iMoreThanStartChar) {
							return null;
						}

						const highlight =
							<React.Fragment key={ `${section.start}-${section.end}` }>
								<SanitizedHtml
									as='span'
									html={ code.substring(i, start) } />
								<SanitizedHtml
									as='span'
									className={
										classNames('code-item', 'tag', className, { link: periscopeOptions?.id })
									}
									html={ code.substring(start, end) }
									onClick={ GetOnClick(periscopeOptions) } />
							</React.Fragment>;

						i = end;

						return highlight;
					}) }
					<SanitizedHtml
						as='span'
						html={ code.substring(i) } />
				</div>
			</code>
		);
	}

	return <SanitizedHtml
		as='code'
		className={
			classNames('code-item', className, {
				link: sections.periscopeOptions?.id,
				tag: sections.periscopeOptions?.id
			})
		}
		html={ code }
		onClick={ GetOnClick(sections.periscopeOptions) } />;
};

